export const buyFreeDialog = ref<{ visible: boolean, offer: Games.Offer | null }>({
  visible: false,
  offer: null
})
